import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {
            return action.payload;
        },
        logout: () => {
            localStorage.removeItem("user");
            localStorage.removeItem("access_token");
            localStorage.removeItem("id_token");
            return null;
        }
    }
});
export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
